import React from 'react'
import ReactSlider from 'react-slider'

interface CollectionTimesSliderProps {
  sliderTimeRange: number[]
  onChange: (value: number[]) => void
  isDisabled?: boolean
}

const CollectionTimesSlider = ({
  sliderTimeRange,
  onChange,
  isDisabled = false,
}: CollectionTimesSliderProps) => {
  return (
    <div className="mb-5">
      <label className="block text-xs text-sky-500 dark:text-sky-400">Available Collection Times</label>
      <span className="block text-xs text-slate-500 dark:text-slate-400">
        Use the slider to select a time range.
      </span>
      <div className="h-[25px] mt-[23px]">
        <ReactSlider
          className="horizontal-slider mb-2"
          thumbClassName="custom-thumb"
          trackClassName="custom-track"
          value={sliderTimeRange}
          min={7}
          max={19}
          ariaLabel={['Start time', 'End time']}
          ariaValuetext={(state) => {
            const time = new Date()
            time.setHours(state.valueNow, 0, 0)
            return new Intl.DateTimeFormat(undefined, {
              hour: 'numeric',
            }).format(time)
          }}
          renderThumb={(props, state) => {
            const time = new Date()
            time.setHours(state.valueNow, 0)
            const display = new Intl.DateTimeFormat(undefined, {
              hour: 'numeric',
            }).format(time)

            return (
              <div
                {...props}
                key={props.key}
              >
                {display}
              </div>
            )
          }}
          pearling
          minDistance={1}
          onChange={(value) => onChange(value)}
          disabled={isDisabled}
        />
      </div>
      <div>
        <p className="text-xs mt-2 font-medium text-slate-500 dark:text-slate-400">
          Please ensure a staff member is available during the selected time range for collection.
        </p>
      </div>
    </div>
  )
}

export default React.memo(CollectionTimesSlider)
